<template>
  <div class="m-2 p-2 flex flex-row">
    <img
      @mouseenter="showDetails=true"
      @mouseleave="showDetails=false"
      class="cursor-pointer w-12 h-12 sm:h-12 sm:w-12 md:h-14 md:w-14 lg:w-17 lg:h-17 rounded-full shadow-xl p-2"
      :src="imgLocation"
    />
    <transition name="fade">
      <div class="ml-6 flex items-center" v-if="!showDetails" :key="imgLocation">
        <h3 class="tracking-wider text-gray-600 font-bold">{{heading}}</h3>
      </div>
    </transition>
    <transition name="slide-fade">
      <div v-if="showDetails" class="ml-6 w-10/12">
        <div class="flex justify-between">
          <h3 class="tracking-wider text-gray-600 text-base font-thin">{{heading}}</h3>
          <span class="text-sm font-thin">{{yearExperience}} year(s)</span>
        </div>
        <div class="overflow-hidden h-2 mb-4 text-xs flex rounded bg-yellow-200 mt-2 flex">
          <div
            :style="`width:${rating*10}%`"
            class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-yellow-600"
          ></div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  props: {
    heading: {
      type: String,
    },
    imgLocation: {
      type: String,
      required: true,
    },
    yearExperience: {
      type: Number,
      required: true,
    },
    rating: {
      type: Number,
      required: true,
    },
    description: {
      type: String,
    },
  },
  data() {
    return {
      showDetails: false,
    };
  },
};
</script>
<style scoped>
.slide-fade-enter-active {
  transition: all 0.5s ease-in;
}

.slide-fade-enter {
  transform: translateX(-10px);
  opacity: 0;
}
.slide-fade-leave-to {
  opacity: 0;
}

.fade-enter-active {
  transition: all 0.5s ease-in;
}
.fade-leave-to {
  transform: translateX(-10px);
}

.fade-enter {
  opacity: 1;
  transform: translateX(-10px);
}
</style>